import React, { useEffect, useState } from "react";
import { padalaServices } from "../services/PadalaServices";
import { adminServices } from "../services/AdminServices";
import DataTable from "react-data-table-component";
import { ReactComponent as TransactionIcon } from '../icons/transactions.svg';
import { useNavigate } from "react-router-dom";
import LoadingModal from "../components/LoadingModal";
import SearchBar from "../components/SearchBar";
import Button from "../components/Button";
import { formatCurrency } from "../tools/tool";
import InputText1 from "../components/InputText1";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import { logExport } from "../services/ExportLogService";
const MerchantPadalaReports = () => {
  const navigate = useNavigate();
  const [padalaList, setPadalaList] = useState(null);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  useEffect(() => {
    setLoading(true);
    getPadala();
  }, []);
  const exportToCSV = async data => {
    if (!data || data.length === 0) return;

    // Log the export
    await logExport('Merchant Padala Reports');
    const headers = ['Transaction Date', 'Merchant Name', 'PDL Number', 'PDL Name', 'Gross Amount', 'Interest Amount', 'Interest Rate', 'Net Amount', 'Reference', 'Sender', 'Processed By'];
    const rows = data.map(row => [new Date(row.reg_date).toLocaleString(), row.merchant_name, row.pdl_number, row.pdl_name, row.gross_amount,
    // raw value
    row.interest_rate,
    // raw value
    `${row.percent}%`, row.net_amount,
    // raw value
    row.ref_no, row.sender, row.processed_by]);
    const csvContent = [headers, ...rows].map(row => row.map(field => `"${field}"`).join(',')).join('\n');
    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'MerchantPadalaReport.csv');
    link.click();
  };
  const getPadala = async () => {
    await adminServices.storeProcedure2('merchant_padala_report', {}).then(r => {
      setPadalaList(null);
      setPadalaList(r.data);
      setData(r.data);
      setFilteredData(r.data);
      let gT = r.data.reduce((total, item) => total + item.net_amount, 0);
      setGrandTotal(gT);
      var _col = [{
        name: 'Transaction Date',
        selector: data => new Date(data.reg_date).toLocaleString(),
        sortable: true
      }, {
        name: 'Merchant Name',
        selector: data => data.merchant_name,
        sortable: true
      }, {
        name: 'PDL Number',
        selector: data => data.pdl_number,
        sortable: true
      }, {
        name: 'PDL Name',
        selector: data => data.pdl_name,
        sortable: true
      }, {
        name: 'Gross Amount',
        selector: data => data.gross_amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Interest Amount',
        selector: data => data.interest_rate.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        sortable: true,
        right: true
      }, {
        name: 'Interest Rate',
        selector: data => data.percent + "%",
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Net Amount',
        selector: data => data.net_amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Reference',
        selector: data => data.ref_no,
        sortable: true
      }, {
        name: 'Sender',
        selector: data => data.sender,
        sortable: true
      }, {
        name: 'Processed By',
        selector: data => data.processed_by,
        sortable: true
      }];
      setColumns(_col);
      setLoading(false);
    }).catch(e => {
      if (e.status == 401) {
        window.location.href = '/';
      }
    });
  };
  const PadalaRange = async () => {
    await adminServices.storeProcedure2('merchant_padala_report_range', {
      dateFrom: dateFrom,
      dateTo: dateTo
    }).then(r => {
      setPadalaList(null);
      setPadalaList(r.data);
      setData(r.data);
      setFilteredData(r.data);
      let gT = r.data.reduce((total, item) => total + item.net_amount, 0);
      setGrandTotal(gT);
      var _col = [{
        name: 'Transaction Date',
        selector: data => new Date(data.reg_date).toLocaleString(),
        sortable: true
      }, {
        name: 'Merchant Name',
        selector: data => data.merchant_name,
        sortable: true
      }, {
        name: 'PDL Number',
        selector: data => data.pdl_number,
        sortable: true
      }, {
        name: 'PDL Name',
        selector: data => data.pdl_name,
        sortable: true
      }, {
        name: 'Gross Amount',
        selector: data => data.gross_amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Interest Rate',
        selector: data => data.interest_rate.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      },, {
        name: 'Interest Rate',
        selector: data => data.percent + "%",
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Net Amount',
        selector: data => data.net_amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }),
        sortable: true,
        right: true,
        headerStyle: {
          textAlign: 'center'
        }
      }, {
        name: 'Reference',
        selector: data => data.ref_no,
        sortable: true
      }, {
        name: 'Sender',
        selector: data => data.sender,
        sortable: true
      }, {
        name: 'Processed By',
        selector: data => data.processed_by,
        sortable: true
      }];
      setColumns(_col);
      setLoading(false);
    }).catch(e => {
      if (e.status == 401) {
        window.location.href = '/';
      }
    });
  };
  return <div>
      <LoadingModal show={loading} message={"Loading Padala Report"} />
      <div style={{
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: 10,
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center'
    }}>
          <TransactionIcon style={{
        width: "50px",
        height: "50px",
        marginRight: "10px",
        background: 'transparent'
      }} />
          Merchant Padala Report ({formatCurrency(grandTotal)})
      </div>

      <div className="flexRow" style={{
      width: '50%'
    }}>
          <InputText1 title={"Date From"} type="date" value={dateFrom} onChange={e => {
        setDateFrom(e.target.value);
      }} />

         <InputText1 title={"Date To"} type="date" value={dateTo} onChange={async e => {
        setDateTo(e.target.value);
      }} />

          <div style={{
        marginTop: 18
      }}>
            <Button variant={"primary"} onClick={PadalaRange}>Search</Button>
          </div>

      </div>

      <div className="flexRow">
        <div className="flexRow filterDiv">
          <SearchBar placeholder="Search Padala Report" onChange={e => {
          const value = e.target.value.toLowerCase();
          const filtered = data.filter(item => Object.keys(item).some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase())));
          setFilteredData(filtered);
          let gT = filtered.reduce((total, item) => total + item.gross_amount, 0);
          setGrandTotal(gT);
        }} />
        </div>
        &nbsp;&nbsp;
        <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end"
      }}>
        </div>
        <div className="spacer"></div>
        <Button variant={"success"} size={'xs'} onClick={() => exportToCSV(filteredData)}> Export to CSV </Button>
      </div>
      <br />
      <DataTable columns={columns} data={filteredData} pagination={false} highlightOnHover style={{
      zIndex: 0
    }} />
    </div>;
};
export default withAuthorization(MerchantPadalaReports, 16);